export enum LinkActionSource {
    contextMenu = 'contextMenu',
    sharingTip = 'sharingTip',
}
